import React, { useState } from 'react';

export const Contact = () => {
  const [submitted,  setSubmitted]  = useState(false);
  const [focusedField, setFocused]  = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    try {
      const response = await fetch('https://formspree.io/f/xjgplzra', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
      });
      if (response.ok) {
        setSubmitted(true);
        form.reset();
      }
    } catch {
      alert('Connection error. Please try again.');
    }
  };

  return (
    <section id="contact" style={contactSection}>

      {/* Section heading outside the card */}
      <div style={{ textAlign: 'center', marginBottom: '50px' }}>
        <p style={nudgeStyle}>GET IN TOUCH</p>
        <h2 style={headingStyle}>
          Say <span style={{ color: '#BC6C25', fontStyle: 'italic' }}>Ciao</span>
        </h2>
        <div style={dividerStyle} />
        <p style={subheadStyle}>
        Questions? I'd love to hear from you!
        </p>
      </div>

      {/* Card */}
      <div style={cardStyle}>
        {!submitted ? (
          <>
            <form onSubmit={handleSubmit} style={formStyle}>

              <div style={inputGroup}>
                <label style={labelStyle}>NAME</label>
                <input
                  type="text"
                  name="name"
                  required
                  style={{ ...inputStyle, ...(focusedField === 'name' ? inputFocusStyle : {}) }}
                  onFocus={() => setFocused('name')}
                  onBlur={() => setFocused(null)}
                />
              </div>

              <div style={inputGroup}>
                <label style={labelStyle}>EMAIL</label>
                <input
                  type="email"
                  name="email"
                  required
                  style={{ ...inputStyle, ...(focusedField === 'email' ? inputFocusStyle : {}) }}
                  onFocus={() => setFocused('email')}
                  onBlur={() => setFocused(null)}
                />
              </div>

              <div style={inputGroup}>
                <label style={labelStyle}>YOUR MESSAGE</label>
                <textarea
                  name="message"
                  rows="4"
                  required
                  style={{ ...inputStyle, ...textareaStyle, ...(focusedField === 'message' ? inputFocusStyle : {}) }}
                  onFocus={() => setFocused('message')}
                  onBlur={() => setFocused(null)}
                />
              </div>

              <button type="submit" style={submitBtnStyle}>SEND MESSAGE</button>

            </form>

            {/* Alternative contact */}
            <div style={altContactStyle}>
              <span style={altContactLabel}>OR EMAIL DIRECTLY</span>
              <a href="mailto:sayciao.school@outlook.com" style={emailLinkStyle}>
                sayciao.school@outlook.com
              </a>
            </div>
          </>
        ) : (
          <div style={successStyle}>
            <span style={{ fontSize: '3.5rem', display: 'block', marginBottom: '20px' }}>🍋</span>
            <h3 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '1.8rem', fontWeight: 400, color: '#283618', margin: '0 0 10px' }}>
              Grazie mille!
            </h3>
            <p style={{ fontSize: '0.9rem', color: '#666', lineHeight: '1.6', margin: '0 0 30px' }}>
              Your message is on its way to my inbox.<br />I'll be in touch soon.
            </p>
            <button onClick={() => setSubmitted(false)} style={resetBtnStyle}>
              ← SEND ANOTHER MESSAGE
            </button>
          </div>
        )}
      </div>

    </section>
  );
};

// ─── Styles ───────────────────────────────────────────────────────────────────
const TERRACOTTA = '#BC6C25';
const DEEP_MOSS  = '#283618';

const contactSection = {
  padding: '120px 8%',
  backgroundColor: '#FDF5E6',
};

const nudgeStyle = {
  fontFamily: "'Montserrat', sans-serif",
  fontSize: '0.65rem',
  letterSpacing: '3px',
  color: TERRACOTTA,
  fontWeight: 700,
  textTransform: 'uppercase',
  marginBottom: '12px',
};

const headingStyle = {
  fontFamily: "'Cormorant Garamond', serif",
  fontSize: '3.5rem',
  fontWeight: 400,
  color: DEEP_MOSS,
  margin: '0 0 20px',
  lineHeight: 1,
};

const dividerStyle = {
  width: '40px',
  height: '1px',
  backgroundColor: TERRACOTTA,
  margin: '0 auto 24px',
  opacity: 0.6,
};

const subheadStyle = {
  fontFamily: "'Montserrat', sans-serif",
  fontSize: '0.9rem',
  color: DEEP_MOSS,
  opacity: 0.65,
  lineHeight: '1.7',
  fontWeight: 300,
  padding: '0 20px',
};

// Card
const cardStyle = {
  maxWidth: '580px',
  margin: '0 auto',
  backgroundColor: '#fff',
  borderRadius: '20px',
  padding: '50px',
  boxShadow: '0 20px 60px rgba(40, 54, 24, 0.07)',
  border: '1px solid rgba(188, 108, 37, 0.08)',
};

// Form
const formStyle  = { display: 'flex', flexDirection: 'column', gap: '28px' };
const inputGroup = { display: 'flex', flexDirection: 'column', gap: '8px' };

const labelStyle = {
  fontSize: '0.6rem',
  letterSpacing: '2px',
  color: TERRACOTTA,
  fontWeight: 700,
  textTransform: 'uppercase',
  fontFamily: "'Montserrat', sans-serif",
};

const inputStyle = {
  backgroundColor: '#fafafa',
  border: '1px solid #eee',
  borderRadius: '10px',
  padding: '14px 16px',
  fontSize: '0.95rem',
  fontFamily: "'Montserrat', sans-serif",
  color: DEEP_MOSS,
  outline: 'none',
  transition: 'border-color 0.2s ease, background-color 0.2s ease',
  width: '100%',
  boxSizing: 'border-box',
};

const inputFocusStyle = {
  borderColor: TERRACOTTA,
  backgroundColor: '#fffbf7',
};

const textareaStyle = {
  resize: 'vertical',
  minHeight: '120px',
};

const submitBtnStyle = {
  backgroundColor: TERRACOTTA,
  color: '#fff',
  border: 'none',
  borderRadius: '10px',
  padding: '16px',
  fontSize: '0.75rem',
  fontWeight: 700,
  letterSpacing: '2px',
  textTransform: 'uppercase',
  cursor: 'pointer',
  fontFamily: "'Montserrat', sans-serif",
  marginTop: '10px',
  transition: 'opacity 0.2s ease',
};

// Alt contact
const altContactStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '8px',
  marginTop: '32px',
  paddingTop: '28px',
  borderTop: '1px solid #f0f0f0',
};

const altContactLabel = {
  fontSize: '0.55rem',
  letterSpacing: '2px',
  color: '#aaa',
  fontWeight: 700,
  textTransform: 'uppercase',
  fontFamily: "'Montserrat', sans-serif",
};

const emailLinkStyle = {
  fontSize: '0.85rem',
  color: TERRACOTTA,
  fontWeight: 700,
  textDecoration: 'none',
  fontFamily: "'Montserrat', sans-serif",
  borderBottom: `1px solid rgba(188, 108, 37, 0.3)`,
  paddingBottom: '2px',
};

// Success
const successStyle = {
  padding: '20px 0',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
};

const resetBtnStyle = {
  background: 'none',
  border: 'none',
  color: TERRACOTTA,
  fontSize: '0.65rem',
  letterSpacing: '1px',
  cursor: 'pointer',
  fontFamily: "'Montserrat', sans-serif",
  fontWeight: 700,
  textTransform: 'uppercase',
};